import { render, staticRenderFns } from "./MonacoEditor.vue?vue&type=template&id=9828478e&scoped=true&"
import script from "./MonacoEditor.ts?vue&type=script&lang=ts&"
export * from "./MonacoEditor.ts?vue&type=script&lang=ts&"
import style0 from "./MonacoEditor.vue?vue&type=style&index=0&id=9828478e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9828478e",
  null
  
)

export default component.exports